import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=4d529171"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=4d529171&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports